import request from '../utils/request'

export function modifyDetail(detailId, qty) {
    return request({
        url: '/api/packing/slip/modify/detail',
        method: 'post',
        data: {
            detail_id: detailId,
            packing_qty: qty
        }
    })
}

export function detailPacking(packingId) {
    return request({
        url: '/api/packing/slip/details',
        method: 'get',
        params: {
            packing_id: packingId
        }
    })
}

export function deliveryPacking(packingId) {
    return request({
        url: '/api/packing/slip/delivery',
        params: {
            packing_id: packingId
        }
    })
}

export function deletePacking(packingId) {
    return request({
        url: '/api/packing/slip/delete',
        method: 'delete',
        params: {
            id: packingId
        }
    })
}

export function deleteDetail(detailId) {
    return request({
        url: '/api/packing/slip/delete/detail',
        method: 'delete',
        params: {
            detail_id: detailId
        }
    })
}

export function importDetail(file){
    let formData = new FormData();
    formData.append('file', file);
    return request({
        url: '/api/packing/slip/import/',
        method: 'post',
        data: formData
    });
}
